import * as api from "~/api";
import { SUPPORTER } from "~/utils/urlApi";

export const getUserDetail = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(`${baseUrl}${SUPPORTER.GET_USER_DETAIL}`, data);

export const getPatient = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(`${baseUrl}${SUPPORTER.GET_PATIENT}`, data);

export const getSupporter = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(`${baseUrl}${SUPPORTER.GET_SUPPORTER}`, data);

export const followSupporter = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(
    `${baseUrl}${SUPPORTER.FOLLOW_SUPPORTER}`,
    data
  );

export const getFollowSupporter = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(
    `${baseUrl}${SUPPORTER.GET_FOLLOW_SUPPORTER}`,
    data
  );

export const getHistoryChat = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(
    `${baseUrl}${SUPPORTER.GET_HISTORY_CHAT}`,
    data
  );

export const getPatientChated = (baseUrl, data) =>
  api.getHttpRequestParamsAsync(
    `${baseUrl}${SUPPORTER.GET_PATIENT_CHATED}`,
    data
  );
